import classes from './index.module.scss';

export interface UpdateBarProps {
  offline?: boolean;
}

export default function UpdateBar({ offline }: UpdateBarProps) {
  const { t } = useTranslation();
  if (!offline) return null;

  return (
    <div className={cls(classes.collectionOffline)}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flex: 'none' }}
      >
        <rect width="16" height="16" rx="8" fill="#FF3B3B" />
        <path
          d="M8 4.88867V9"
          stroke="white"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="7.99994" cy="11.0663" r="0.733333" fill="white" />
      </svg>

      <span className={classes.text}>{t('general.networkNotConnected')}</span>
      <span className={classes.btn} onClick={() => window.location.reload()}>
        {t('buttons.refresh')}
      </span>
    </div>
  );
}
